<!-- Fabs (Floating Action Buttons) in cards start -->
<section id="fabs-examples">
  <div class="row">
    <div class="col-12">
      <div class="content-header">Fabs (Floating Action Buttons) in cards</div>
      <p class="content-sub-header mb-1">Cards require a small amount of markup and classes to provide you with as much control as possible. These classes and markup are flexible though and can typically be remixed and extended with ease. For example, if your card has no flush content like images, feel free to put the <code>.card-content</code> class on the <code>.card</code> element to consolidate your markup.</p>
    </div>
  </div>

  <div class="row match-height">
    <div class="col-lg-4 col-md-12 col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-img">
            <img class="card-img-top img-fluid" src="assets/img/photos/14.jpg" alt="Card image cap">
            <h4 class="card-title">Card title</h4>
            <a class="btn btn-floating halfway-fab bg-warning"><i class="ft-plus"></i></a>
          </div>
          <div class="card-body">
            <p class="card-text">Icing powder caramels macaroon. Toffee sugar plum brownie pastry gummies jelly.</p>
            <button type="button" class="btn btn-warning">Go somewhere</button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-12 col-12">
      <div class="card">
        <div class="card-header mb-3">
          <h4 class="card-title">Card title</h4>
          <h6 class="card-subtitle text-muted mb-0">Support card subtitle</h6>
        </div>
        <div class="card-content">
          <div class="card-img">
            <img class="img-fluid" src="assets/img/photos/15.jpg" alt="Card image cap">
            <a class="btn btn-floating halfway-fab btn-large bg-danger"><i class="ft-plus"></i></a>
          </div>
          <div class="card-body">
            <p class="card-text">Bear claw sesame snaps gummies chocolate.</p>
          </div>
        </div>
        <div class="card-footer pt-0">
          <a class="card-link danger">Card link</a>
          <a class="card-link danger">Another link</a>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-12 col-12">
      <div class="card overflow-hidden">
        <div class="card-content">
          <div class="card-img">
            <ngb-carousel>
              <ng-template ngbSlide>
                <img src="assets/img/photos/17.jpg" class="d-block w-100" alt="First slide">
              </ng-template>
              <ng-template ngbSlide>
                <img src="assets/img/photos/13.jpg" class="d-block w-100" alt="Second slide">
              </ng-template>
              <ng-template ngbSlide>
                <img src="assets/img/photos/12.jpg" class="d-block w-100" alt="Third slide">
              </ng-template>
            </ngb-carousel>
            <a class="btn btn-floating halfway-fab btn-large bg-warning"><i class="ft-plus"></i></a>
          </div>
          <div class="card-body">
            <h4 class="card-title">Card title</h4>
            <p class="card-text">Sweet halvah dragée jelly-o halvah carrot cake oat cake. Donut jujubes jelly chocolate
              cake.</p>
            <button type="button" class="btn btn-warning">Go somewhere</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- // Fabs section end -->

<!-- Horizontal cards start -->
<section id="horizontal-examples">
  <div class="row">
    <div class="col-12">
      <div class="content-header">Horizontal cards</div>
      <p class="content-sub-header mb-1">Cards with horizontal image.</p>
    </div>
  </div>

  <div class="row match-height">
    <div class="col-xl-6 col-lg-12">
      <div class="card overflow-hidden">
        <div class="row">
          <div class="col-sm-6 col-12">
            <div class="card-img">
              <ngb-carousel>
                <ng-template ngbSlide>
                  <img src="assets/img/photos/01.jpg" class="d-block w-100" alt="First slide">
                </ng-template>
                <ng-template ngbSlide>
                  <img src="assets/img/photos/10.jpg" class="d-block w-100" alt="Second slide">
                </ng-template>
                <ng-template ngbSlide>
                  <img src="assets/img/photos/11.jpg" class="d-block w-100" alt="Third slide">
                </ng-template>
              </ngb-carousel>
            </div>
          </div>
          <div class="col-sm-6 col-12 d-flex align-items-center">
            <div class="card-body">
              <div class="align-self-center">
                <div class="px-3">
                  <h4 class="card-title mb-3">Card title</h4>
                  <p class="card-text">Sweet halvah dragée jelly-o halvah carrot cake oat cake.</p>
                  <button type="button" class="btn btn-success">Go somewhere</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-6 col-lg-12">
      <div class="card overflow-hidden">
        <div class="row">
          <div class="col-sm-6 col-12 d-flex align-items-center">
            <div class="card-body">
              <div class="align-self-center">
                <div class="px-3">
                  <h4 class="card-title mb-3">Card title</h4>
                  <p class="card-text">Toffee sugar plum brownie pastry gummies jelly.</p>
                  <button type="button" class="btn btn-danger">Go somewhere</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-12">
            <div class="card-img">
              <img class="img-fluid" src="assets/img/photos/06.jpg" alt="Card image cap">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- // Horizontal cards end -->


<!-- Overlap Image Cards start -->
<section id="overlap-image-examples">
  <div class="row">
    <div class="col-12">
      <div class="content-header">Overlap Image Cards</div>
      <p class="content-sub-header mb-3">Overlap Image Cards</p>
    </div>
  </div>

  <div class="row match-height">
    <div class="col-lg-4 col-md-4 col-12 mb-2 mb-md-0">
      <div class="card card-inverse bg-primary text-center">
        <div class="card-content">
          <div class="card-img overlap">
            <img src="assets/img/elements/11.png" alt="element 06" width="235" class="mb-1">
          </div>
          <div class="card-body mt-3">
            <h4 class="card-title">New Arrival</h4>
            <p class="card-text">Donut toffee candy brownie soufflé macaroon.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-4 col-12 mb-2 mb-md-0">
      <div class="card card-inverse bg-success text-center">
        <div class="card-content">
          <div class="card-img overlap">
            <img src="assets/img/elements/14.png" alt="element 03" width="170">
          </div>
          <div class="card-body mt-3">
            <h4 class="card-title">Brand Minute</h4>
            <p class="card-text">Donut toffee candy brownie soufflé macaroon.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-4 col-12">
      <div class="card card-inverse bg-info text-center">
        <div class="card-content">
          <div class="card-img overlap">
            <img src="assets/img/elements/07.png" alt="element 07" width="225">
          </div>
          <div class="card-body mt-1">
            <h4 class="card-title">Brand Minute</h4>
            <p class="card-text">Donut toffee candy brownie soufflé macaroon.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- // Overlap Image Cards end -->

<!-- Weather cards start -->
<section id="weather-examples">
  <div class="row">
    <div class="col-12">
      <div class="content-header">Weather cards</div>
      <p class="content-sub-header mb-1">Weekly weather cards.</p>
    </div>
  </div>

  <div class="row match-height">
    <div class="col-lg-6 col-md-12 col-12">
      <div class="card overflow-hidden">
        <div class="card-content">
          <div class="card-img">
            <img class="card-img-top img-fluid height-300" src="assets/img/photos/weather-1.jpg" alt="Card image cap">
            <div class="card-img-overlay overlay-dark">
              <h4 class="card-title">Sunny</h4>
            </div>
            <a class="btn btn-floating halfway-fab bg-primary"><i class="ft-plus"></i></a>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-2 text-center">
                <span class="d-block">Mon</span>
                <i class="wi wi-day-sunny d-block primary font-large-1 my-3"></i>
                <span class="d-block">13&deg;</span>
              </div>
              <div class="col-2 text-center">
                <span class="d-block">Tue</span>
                <i class="wi wi-day-cloudy d-block primary font-large-1 my-3"></i>
                <span class="d-block">12&deg;</span>
              </div>
              <div class="col-2 text-center">
                <span class="d-block">Wed</span>
                <i class="wi wi-day-cloudy-gusts d-block primary font-large-1 my-3"></i>
                <span class="d-block">10&deg;</span>
              </div>
              <div class="col-2 text-center">
                <span class="d-block">Thu</span>
                <i class="wi wi-day-cloudy-windy d-block primary font-large-1 my-3"></i>
                <span class="d-block">12&deg;</span>
              </div>
              <div class="col-2 text-center">
                <span class="d-block">Fri</span>
                <i class="wi wi-day-fog d-block primary font-large-1 my-3"></i>
                <span class="d-block">9&deg;</span>
              </div>
              <div class="col-2 text-center">
                <span class="d-block">Sat</span>
                <i class="wi wi-day-lightning d-block primary font-large-1 my-3"></i>
                <span class="d-block">6&deg;</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-6 col-md-12 col-12">
      <div class="card overflow-hidden">
        <div class="card-content">
          <div class="card-img">
            <img class="card-img-top img-fluid height-300" src="assets/img/photos/weather-2.png" alt="Card image cap">
            <div class="card-img-overlay overlay-dark">
              <h4 class="card-title m-0">Snowy</h4>
            </div>
            <a class="btn btn-floating halfway-fab bg-danger"><i class="ft-plus"></i></a>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-2 text-center">
                <span class="d-block">Mon</span>
                <i class="wi wi-day-cloudy d-block danger font-large-1 my-3"></i>
                <span class="d-block">13&deg;</span>
              </div>
              <div class="col-2 text-center">
                <span class="d-block">Tue</span>
                <i class="wi wi-day-hail d-block danger font-large-1 my-3"></i>
                <span class="d-block">12&deg;</span>
              </div>
              <div class="col-2 text-center">
                <span class="d-block">Wed</span>
                <i class="wi wi-day-showers d-block danger font-large-1 my-3"></i>
                <span class="d-block">10&deg;</span>
              </div>
              <div class="col-2 text-center">
                <span class="d-block">Thu</span>
                <i class="wi wi-day-sprinkle d-block danger font-large-1 my-3"></i>
                <span class="d-block">12&deg;</span>
              </div>
              <div class="col-2 text-center">
                <span class="d-block">Fri</span>
                <i class="wi wi-day-storm-showers d-block danger font-large-1 my-3"></i>
                <span class="d-block">9&deg;</span>
              </div>
              <div class="col-2 text-center">
                <span class="d-block">Sat</span>
                <i class="wi wi-day-sunny d-block danger font-large-1 my-3"></i>
                <span class="d-block">6&deg;</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- // Weather cards end -->


<!-- Background variants section start -->
<section id="bg-variants">
  <div class="row">
    <div class="col-12">
      <div class="content-header">Background variants</div>
      <p class="content-sub-header mb-1">Cards include their own variant classes for quickly changing the <code>background-color</code> and <code>border-color</code> of a card. Darker colors require the use of <code>.card-inverse</code>. Cards include a class for quickly toggling the text color. By default, cards use dark text and assume a light background. Add <code>.card-inverse</code> for white text and specify the <code>background-color</code> and <code>border-color</code> to go with it. You can also use <code>.card-inverse</code> with the contextual backgrounds variants.</p>
    </div>
  </div>
  <div class="row match-height">
    <div class="col-md-6 col-12">
      <div class="card card-inverse bg-warning text-center">
        <div class="card-content">
          <div class="card-body">
            <div class="row d-flex">
              <div class="col align-self-center">
                <img src="assets/img/elements/01.png" alt="element 01" width="190" class="mt-sm-2">
              </div>
              <div class="col align-self-center">
                <h4 class="card-title mb-3">Brand Minute</h4>
                <p class="card-text">Donut toffee candy brownie soufflé macaroon.</p>
                <button class="btn btn-warning btn-darken-3">Buy Now</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-12">
      <div class="card card-inverse bg-primary text-center">
        <div class="card-content">
          <div class="card-body mt-sm-2">
            <img src="assets/img/elements/06.png" alt="element 02" width="235" class="mb-3">
            <h3 class="card-title">Ceramic Bottle</h3>
            <p class="card-text">456 items</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-12">
      <div class="card card-inverse bg-success text-center">
        <div class="card-content">
          <div class="card-body">
            <div class="row d-flex">
              <div class="col align-self-center mt-sm-2 ml-sm-3 mb-2 mb-sm-0">
                <h4 class="card-title mb-3">Brand Minute</h4>
                <p class="card-text">Donut toffee candy brownie soufflé macaroon.</p>
                <button class="btn btn-success btn-darken-3">Buy Now</button>
              </div>
              <div class="col align-self-center">
                <img src="assets/img/elements/14.png" alt="element 03" width="170" class="float-sm-right mt-sm-1">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-12">
      <div class="card card-inverse bg-info text-center">
        <div class="card-content">
          <div class="card-body">
            <div class="row d-flex">
              <div class="col align-self-center mb-2 mb-sm-0">
                <img src="assets/img/elements/07.png" alt="element 04" width="200" class="float-sm-left mt-sm-1">
              </div>
              <div class="col align-self-center mr-sm-4">
                <h4 class="card-title mb-3">New Arrival</h4>
                <p class="card-text">Donut toffee candy brownie soufflé macaroon.</p>
                <button class="btn btn-info btn-darken-3">Buy Now</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-12">
      <div class="card card-inverse bg-secondary text-center">
        <div class="card-content">
          <div class="card-body pt-2">
            <img src="assets/img/elements/04.png" alt="element 05" width="235" class="mb-2">
            <h4 class="card-title">Storage Device</h4>
            <p class="card-text">945 items</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-12">
      <div class="card card-inverse bg-danger text-center">
        <div class="card-content">
          <div class="card-body mt-sm-3">
            <div class="row d-flex">
              <div class="col align-self-center mb-2 mb-sm-0">
                <h4 class="card-title mb-3">New Arrival</h4>
                <p class="card-text">Donut toffee candy brownie soufflé macaroon.</p>
                <button class="btn btn-danger btn-darken-3 white">Buy Now</button>
              </div>
              <div class="col align-self-center">
                <img src="assets/img/elements/11.png" alt="element 06" width="235">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Background variants section end -->

<!-- Outline variants section start -->
<section id="outline-variants">
  <div class="row">
    <div class="col-12">
      <div class="content-header">Outline variants</div>
      <p class="content-sub-header mb-1">In need of a colored card, but not the hefty background colors they bring? Replace the default modifier classes with the <code>.card-outline-*</code> ones to style just the <code>border-color</code> of a card.</p>
    </div>
  </div>
  <div class="row match-height">
    <div class="col-md-6 col-12">
      <div class="card card-outline-warning box-shadow-0 text-center">
        <div class="card-content">
          <div class="card-body">
            <div class="row d-flex">
              <div class="col align-self-center">
                <img src="assets/img/elements/01.png" alt="element 01" width="190" class="mt-sm-2">
              </div>
              <div class="col align-self-center">
                <h4 class="card-title mb-3">Brand Minute</h4>
                <p class="card-text">Donut toffee candy brownie soufflé macaroon.</p>
                <button class="btn bg-light-warning">Buy Now</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-12">
      <div class="card card-outline-primary box-shadow-0 text-center">
        <div class="card-content">
          <div class="card-body mt-sm-2">
            <img src="assets/img/elements/06.png" alt="element 02" width="235" class="mb-3">
            <h3 class="card-title">Ceramic Bottle</h3>
            <p class="card-text">456 items</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-12">
      <div class="card card-outline-success box-shadow-0 text-center">
        <div class="card-content">
          <div class="card-body">
            <div class="row d-flex">
              <div class="col align-self-center mt-sm-2 ml-sm-3 mb-2 mb-sm-0">
                <h4 class="card-title mb-3">Brand Minute</h4>
                <p class="card-text">Donut toffee candy brownie soufflé macaroon.</p>
                <button class="btn bg-light-success">Buy Now</button>
              </div>
              <div class="col align-self-center">
                <img src="assets/img/elements/14.png" alt="element 03" width="170" class="float-sm-right mt-sm-1">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-12">
      <div class="card card-outline-info box-shadow-0 text-center">
        <div class="card-content">
          <div class="card-body">
            <div class="row d-flex">
              <div class="col align-self-center mb-2 mb-sm-0">
                <img src="assets/img/elements/07.png" alt="element 04" width="200" class="float-sm-left mt-sm-1">
              </div>
              <div class="col align-self-center mr-sm-4">
                <h4 class="card-title mb-3">New Arrival</h4>
                <p class="card-text">Donut toffee candy brownie soufflé macaroon.</p>
                <button class="btn bg-light-info">Buy Now</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-12">
      <div class="card card-outline-secondary box-shadow-0 text-center">
        <div class="card-content">
          <div class="card-body pt-2">
            <img src="assets/img/elements/04.png" alt="element 05" width="235" class="mb-2">
            <h4 class="card-title">Storage Device</h4>
            <p class="card-text">945 items</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-12">
      <div class="card card-outline-danger box-shadow-0 text-center">
        <div class="card-content">
          <div class="card-body mt-sm-3">
            <div class="row d-flex">
              <div class="col align-self-center mb-2 mb-sm-0">
                <h4 class="card-title mb-3">New Arrival</h4>
                <p class="card-text">Donut toffee candy brownie soufflé macaroon.</p>
                <button class="btn bg-light-danger white">Buy Now</button>
              </div>
              <div class="col align-self-center">
                <img src="assets/img/elements/11.png" alt="element 06" width="235">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Outline variants section end -->

<!-- Groups section start -->
<section id="groups">
  <div class="row">
    <div class="col-12">
      <div class="content-header">Groups</div>
      <p class="content-sub-header mb-1">Use card groups to render cards as a single, attached element with equal width and height columns. By default, card groups use <code>display: table;</code> and <code>table-layout: fixed;</code> to achieve their uniform sizing. However, enabling flexbox mode can switch that to use <code>display: flex;</code> and provide the same effect.</p>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card-group">
        <div class="card">
          <div class="card-content">
            <img class="card-img-top img-fluid" src="assets/img/photos/04.jpg" alt="Card image cap">
            <div class="card-body">
              <h4 class="card-title">Card title</h4>
              <p class="card-text">This card has supporting text below as a natural lead-in to additional content.</p>
            </div>
          </div>
          <div class="card-footer pt-0">
            <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
          </div>
        </div>
        <div class="card">
          <div class="card-content">
            <img class="img-fluid" src="assets/img/photos/01.jpg" alt="Card image cap">
            <div class="card-body">
              <h4 class="card-title">Card title</h4>
              <p class="card-text">This card has supporting text below as a natural lead-in to additional content.</p>
            </div>
          </div>
          <div class="card-footer pt-0">
            <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
          </div>
        </div>
        <div class="card">
          <div class="card-content">
            <img class="img-fluid" src="assets/img/photos/07.jpg" alt="Card image cap">
            <div class="card-body">
              <h4 class="card-title">Card title</h4>
              <p class="card-text">This card has supporting text below as a natural lead-in to additional content.</p>
            </div>
          </div>
          <div class="card-footer pt-0">
            <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
          </div>
        </div>
        <div class="card">
          <div class="card-content">
            <img class="card-img-top img-fluid" src="assets/img/photos/02.jpg" alt="Card image cap">
            <div class="card-body">
              <h4 class="card-title">Card title</h4>
              <p class="card-text">This card has supporting text below as a natural lead-in to additional content.</p>
            </div>
          </div>
          <div class="card-footer pt-0">
            <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Groups section end -->

<!-- Decks section start -->
<section id="decks">
  <div class="row mt-2">
    <div class="col-12">
      <div class="content-header">Decks</div>
      <p class="content-sub-header mb-1">Need a set of equal width and height cards that aren’t attached to one another? Use card decks. By default, card decks require two wrapping elements: <code>.card-deck-wrapper</code> and a <code>.card-deck</code>. We use table styles for the sizing and the gutters on <code>.card-deck</code>. The <code>.card-deck-wrapper</code> is used to negative margin out the <code>border-spacing</code> on the <code>.card-deck</code>.</p>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card-deck-wrapper">
        <div class="card-deck">
          <div class="card">
            <div class="card-content">
              <img class="card-img-top img-fluid" src="assets/img/photos/05.jpg" alt="Card image cap">
              <div class="card-body">
                <h4 class="card-title">Card title</h4>
                <p class="card-text">This card has supporting text below as a natural lead-in to additional content.</p>
              </div>
            </div>
            <div class="card-footer pt-0">
              <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
            </div>
          </div>
          <div class="card">
            <div class="card-content">
              <img class="img-fluid" src="assets/img/photos/09.jpg" alt="Card image cap">
              <div class="card-body">
                <h4 class="card-title">Card title</h4>
                <p class="card-text">This card has supporting text below as a natural lead-in to additional content.</p>
              </div>
            </div>
            <div class="card-footer pt-0">
              <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
            </div>
          </div>
          <div class="card">
            <div class="card-content">
              <img class="img-fluid" src="assets/img/photos/10.jpg" alt="Card image cap">
              <div class="card-body">
                <h4 class="card-title">Card title</h4>
                <p class="card-text">This card has supporting text below as a natural lead-in to additional content.</p>
              </div>
            </div>
            <div class="card-footer pt-0">
              <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
            </div>
          </div>
          <div class="card">
            <div class="card-content">
              <img class="card-img-top img-fluid" src="assets/img/photos/03.jpg" alt="Card image cap">
              <div class="card-body">
                <h4 class="card-title">Card title</h4>
                <p class="card-text">This card has supporting text below as a natural lead-in to additional content.</p>
              </div>
            </div>
            <div class="card-footer pt-0">
              <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Decks section end -->


<!-- Columns section start -->
<section id="columns">
  <div class="row mt-2">
    <div class="col-12">
      <div class="content-header">Columns</div>
      <p class="content-sub-header mb-1">Cards can be organized into Masonry-like columns with just CSS by wrapping them in <code>.card-columns</code>. Only applies to small devices and above. <strong>Heads up!</strong> This is <strong>not available in IE9</strong> and below as they have no support for the column-* CSS properties.</p>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 mt-1">
      <div class="card-columns">
        <div class="card">
          <div class="card-content">
            <img class="card-img-top img-fluid" src="assets/img/photos/06.jpg" alt="Card image cap">
            <div class="card-body">
              <h4 class="card-title">Card title</h4>
              <p class="card-text">Some quick example text to build on the card title and make up the bulk of the
                card's content.</p>
              <button type="button" class="btn btn-outline-warning">Go somewhere</button>
            </div>
          </div>
        </div>
        <div class="card card-inverse bg-success text-center">
          <div class="card-content">
            <div class="card-body">
            <div class="row d-flex">
              <div class="col-lg-6 col-12 align-self-center mb-3 mb-lg-0">
                <img src="assets/img/elements/15.png" alt="element 01" width="120">
              </div>
              <div class="col-lg-6 col-12 align-self-center">
                <h4 class="card-title mb-3">Brand Minute</h4>
                <p class="card-text">Donut toffee candy brownie soufflé macaroon.</p>
                <button class="btn btn-success btn-darken-3">Buy Now</button>
              </div>
            </div>
          </div>
          </div>
        </div>
        <div class="card card-inverse bg-warning text-center border-0 box-shadow-0">
          <div class="card-content">
            <div class="card-body pt-2">
              <img src="assets/img/elements/04.png" alt="element 05" width="235" class="mb-2 img-fluid">
              <h4 class="card-title">Storage Device</h4>
              <p class="card-text mb-2">945 items</p>
            </div>
          </div>
        </div>
        <div class="card card-inverse bg-primary text-center border-0 box-shadow-0">
          <div class="card-content">
            <div class="card-body">
              <img src="assets/img/elements/06.png" alt="element 02" width="225" class="mb-3 img-fluid">
              <h3 class="card-title">Ceramic Bottle</h3>
              <p class="card-text">456 items</p>
            </div>
          </div>
        </div>
        <div class="card border-0 box-shadow-0">
          <div class="card-content">
            <div class="card-body">
              <h4 class="card-title mb-2">Bottom Image Cap</h4>
              <p class="card-text">Jelly-o sesame snaps cheesecake topping. Cupcake fruitcake macaroon donut pastry
                gummies tiramisu
                chocolate bar muffin. Dessert bonbon caramels brownie chocolate bar chocolate tart dragée.</p>
              <p class="card-text">Cupcake fruitcake macaroon donut pastry gummies tiramisu chocolate bar muffin.</p>
              <p class="card-text pt-1"><small class="text-muted">Last updated 3 mins ago</small></p>
            </div>
            <img class="card-img-bottom img-fluid" src="assets/img/photos/11.jpg" alt="Card image cap">
          </div>
        </div>
        <div class="card card-inverse border-0 box-shadow-0 overflow-hidden">
          <div class="card-content">
            <img class="card-img img-fluid" src="assets/img/photos/04.jpg" alt="Card image">
            <div class="card-img-overlay overlay-info">
              <h4 class="card-title">Inverse Text</h4>
              <p class="card-text">Sugar plum tiramisu sweet. Cake jelly marshmallow cotton candy chupa chups carrot
                cake topping
                chupa chups.</p>
              <p class="card-text"><small class="text-muted white">Last updated 3 mins ago</small></p>
            </div>
          </div>
        </div>
        <div class="card card-inverse border-0 box-shadow-0 overflow-hidden">
          <div class="card-content">
            <img class="card-img img-fluid" src="assets/img/photos/08.jpg" alt="Card image">
            <div class="card-img-overlay overlay-warning">
              <h4 class="card-title">Inverse Text</h4>
              <p class="card-text">Sugar plum tiramisu sweet. Cake jelly marshmallow cotton candy chupa chups carrot
                cake topping
                chupa chups.</p>
              <p class="card-text"><small class="text-muted white">Last updated 3 mins ago</small></p>
            </div>
          </div>
        </div>
        <div class="card card-outline-info text-center box-shadow-0">
          <div class="card-content">
            <div class="card-body">
              <div class="row d-flex">
                <div class="col-lg-6 col-12 align-self-center mb-2 mb-lg-0">
                  <img src="assets/img/elements/13.png" alt="element 04" width="135">
                </div>
                <div class="col-lg-6 col-12 align-self-center">
                  <h4 class="card-title mb-3">New Arrival</h4>
                  <p class="card-text">Donut toffee candy brownie soufflé macaroon.</p>
                  <button class="btn bg-light-info">Buy Now</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card border-0 box-shadow-0">
          <div class="card-content">
            <img class="card-img img-fluid" src="assets/img/photos/02.jpg" alt="Card image cap">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Columns section end -->
